













































import Vue from 'vue';
import Header from './components/header/header.vue';
import { ErrorBoundary } from 'vue-error-boundary';
import sToastComponent from './services/sToast/sToast.vue';
import Error from './utilities/error-boundry.vue';
import http from '../src/services/http-common';
import SessionValidation from '../src/services/api/sessionValidation';
import store from './store';
import { mapGetters, mapMutations, mapActions } from 'vuex';
const axios = require('axios');

export default Vue.extend({
  name: 'App',
  components: {
    Header,
    sToastComponent,
    ErrorBoundary,
  },
  data: () => ({
    refCount: 0,
    isLoading: false,
    fallBack: Error,
    ifDataInStore: false,
  }),
  computed: {
    ...mapGetters(['SESSIONPAYLOAD']),
  },
  methods: {
    ...mapActions(['setFilterData']),
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.isLoading = this.refCount > 0;
        this.isLoading = false;
      }
    },
  },
  created() {
    /* loaderDisplay display */
    http.interceptors.request.use(
      (config) => {
        this.setLoading(true);
        return config;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );

    http.interceptors.response.use(
      (response) => {
        this.setLoading(false);
        return response;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );

    SessionValidation.sessionValidate().then(
      async (response) => {
        this.ifDataInStore = true;
        if (
          response.status === 200 /* && response.data.responseCode === "00" */
        ) {
          this.successresponse = response.data.description;
          store.commit('SESSIONPAYLOADVALUE', response.data.payload);
          store.commit('setAppLang', this.$store.state.sessionPayload.lang);
          //store.commit('setAppLang', 'EN');
          store.commit('setAppMode', this.$store.state.sessionPayload.mode);
          //agentid = this.$store.state.sessionPayload.agentId;
          store.commit(
            'setAppAgentId',
            this.$store.state.sessionPayload.agentId
          );

          //comment the below code as we are not getting Mode in session response
          //store.commit("setAppAgentId", '12345');
          //store.commit("setAppMode", 'Web');
          //store.commit('setAppLang', 'En');

          //Setting History Module Session In Store
          store.commit('setHistoryModuleSession', response.data.udf1);
          //Setting transCategory and nonTransSubCategory
          if (response.data.payload.transCategory) {
            let stringArray = response.data.payload.transCategory.split(',');
            this.$store.state.validMainCategoryIds = stringArray.map((e) => e);
          }
          if (response.data.payload.nonTransSubCategory) {
            let stringArray = response.data.payload.nonTransSubCategory.split(
              ','
            );
            this.$store.state.notValidSubCategoryIds = stringArray.map(
              (e) => e
            );
          }

          console.log(this.$store.state.sessionPayload);
          this.ifDataInStore = true;
        } else {
          this.ifDataInStore = true;
          this.$router.push({ name: 'NotFound' });
        }
      },
      (error) => {
        this.ifDataInStore = true;
        this.$router.push({ name: 'NotFound' });
      }
    );
  },
  mounted() {},
});
